<template>
  <div>
    <h1>OS1 monthly</h1>
    <div v-html="content" />
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Os1Monthly",
  metaInfo() {
    return {
      title: "OS1 Monthly",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return { content: null };
  },
  methods: {
    fetchOs1Monthly() {
      nbmlaw
        .get(`/cors/admin/file/os1monthly`)
        .then(response => {
          // console.log(response.data);
          this.content = response.data;
        })
        .catch(() => {});
    }
  },
  created() {
    this.fetchOs1Monthly();
  }
};
</script>

<style>
</style>
